"use client";

import * as React from "react";
import { Plus } from "lucide-react";
import { cn } from "../../../lib/utils";
import { kanbanAddButtonVariants } from "./constants";
import type { KanbanAddButtonProps } from "./types";

/**
 * The column's footer add affordance. It only ever *asks* — the caller decides
 * what creating means.
 *
 * It used to swap itself for a bare title field and create the card straight
 * from it. That put two different creation surfaces on one board (the column
 * header's `+` opened the create dialog, this one did not) and the inline one
 * could only carry a title, so anything created here still had to be opened and
 * filled in. The dialog is the one path now.
 */
const KanbanAddButton = React.forwardRef<
  HTMLButtonElement,
  KanbanAddButtonProps
>(({ className, onClick, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    onClick={onClick}
    className={cn(kanbanAddButtonVariants({ variant: "full" }), className)}
    {...props}
  >
    <Plus className="mr-1 size-3.5" aria-hidden="true" />
    Add item
  </button>
));

KanbanAddButton.displayName = "KanbanAddButton";

export { KanbanAddButton };
